import { render, staticRenderFns } from "./viewDashboard.vue?vue&type=template&id=261a2334&scoped=true"
import script from "./viewDashboard.vue?vue&type=script&lang=js"
export * from "./viewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a2334",
  null
  
)

export default component.exports